import React, { Fragment } from 'react';
import { ToastContainer } from 'react-toastify';
import Background from '../../assest/bkschoolvn/bkschoolvn_bg.webp';

const Layout = ({ children }) => {
  return (
    <Fragment>
      <main className="relative flex min-w-screen min-h-screen justify-center items-center overflow-hidden">
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${Background})`, filter: 'blur(6px)' }}
        />
        <div className="relative z-10 w-full h-full flex justify-center items-center">
          {children}
        </div>
      </main>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme={'colored'}
        limit={3}
      />
    </Fragment>
  );
};

export default Layout;
